import PropTypes from 'prop-types'

import shipOverviewBay from './shipOverviewBay'
import shipOverviewDevice from './shipOverviewDevice'

export default PropTypes.shape({
  accommodationAfterBay: PropTypes.number.isRequired,
  bays: PropTypes.arrayOf(shipOverviewBay).isRequired,
  devices: PropTypes.arrayOf(shipOverviewDevice),
  engineAfterBay: PropTypes.number,
})
